import { render, staticRenderFns } from "./userRight.vue?vue&type=template&id=1551f25d&"
import script from "./userRight.vue?vue&type=script&lang=js&"
export * from "./userRight.vue?vue&type=script&lang=js&"
import style0 from "./userRight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports